module.exports = __webpack_public_path__ + "static/media/yt-pandas.0780f606.mov";